export function toggleDestini() {
	const modal = document.querySelector("#modal-destini");
	console.log("modal found", modal);
	if (modal) {
		modal.showModal();
	}
}

export function toggleModal() {
	console.warn("This is not an available function anymore.");
}

/* get height of product header */
export function resizeFn() {
	const mediaQuery = window.matchMedia("(min-width: 768px)");

	let height = document.querySelector(
		".single-product .product-details"
	).offsetHeight;
	let mobileHeight =
		height +
		document.querySelector(".single-product .product-image").offsetHeight;
	let notifyHeight = document.querySelector(
		".notify-container-content"
	)?.offsetHeight;

	if (notifyHeight) {
		mobileHeight += notifyHeight;
		height += notifyHeight;
	}
	let slant = document.querySelector(".bg-color-slant");
	let headerHeight = document.querySelector(
		".single-product header"
	).offsetHeight;
	let slantSvg = document.querySelector(".bg-color-slant .slant-svg");

	if (mediaQuery.matches) {
		slant.style.height = height + headerHeight + 26 + "px";
		slantSvg.style.top = height + headerHeight + 25 + "px";
	} else {
		console.log(30, height, mobileHeight, headerHeight);
		slant.style.height = mobileHeight + headerHeight + 60 + "px"; //+ 26 + "px";
		slantSvg.style.top = mobileHeight + headerHeight + 59 + "px"; //+ 25 + "px";
	}
}

const root = document.querySelector(":root");
export const setStickyOffset = () => {
	const affectsStickyPosition = [
		...document.querySelectorAll("#masthead, #banner-container"),
	];
	const stickyOffset = affectsStickyPosition.reduce((acc, curr) => {
		console.log("offset!!!", curr, curr.offsetHeight);
		return (acc += curr.offsetHeight);
	}, 0);

	console.log("offset + 20", stickyOffset + 20);
	root.style.setProperty("--sticky-offset", `${stickyOffset + 20}px`);
};
